// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import type { AdvisoryInstitutionSearchItem } from '@shared/data-access/types/brokerage/brokerage-types';

export type InstitutionCatalogOption = AdvisoryInstitutionSearchItem & {
  listKey: string;
  isSelected: boolean;
};

export const buildInstitutionListKey = (
  institution: Pick<AdvisoryInstitutionSearchItem, 'provider' | 'country' | 'id'>,
): string => `${institution.provider}-${institution.country}-${institution.id}`;

export const mapInstitutionCatalogOptions = (
  institutions: AdvisoryInstitutionSearchItem[] | undefined,
  selectedListKey?: string,
): InstitutionCatalogOption[] =>
  (institutions ?? []).map(institution => {
    const listKey = buildInstitutionListKey(institution);

    return {
      ...institution,
      listKey,
      isSelected: selectedListKey === listKey,
    };
  });

export const findInstitutionCatalogOptionByListKey = (
  options: InstitutionCatalogOption[],
  listKey: string | undefined,
): InstitutionCatalogOption | undefined =>
  options.find(option => option.listKey === listKey);
